import { render, staticRenderFns } from "./FooterStyle.vue?vue&type=template&id=4266592c&scoped=true&"
import script from "./FooterStyle.vue?vue&type=script&lang=js&"
export * from "./FooterStyle.vue?vue&type=script&lang=js&"
import style0 from "./FooterStyle.vue?vue&type=style&index=0&id=4266592c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4266592c",
  null
  
)

export default component.exports